// extracted by mini-css-extract-plugin
module.exports = {"icon-list":"stories_icon-list__1jB2s"};